// @flow
import type { GradProgram as ApiGradProgram } from 'api/gradSchools';
import type { Action } from '../../actions/gradSchools/gradPrograms';

export type GradProgram = {
  ...$Exact<ApiGradProgram>,
  isFetching: boolean
};

export type State = {
  byId: {
    [string]: GradProgram
  }
};

export default function gradPrograms(
  state: State = { byId: {} },
  action: Action
) {
  switch (action.type) {
    case 'GRAD_SCHOOLS_FETCH_PROGRAM_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.programId]: {
            ...state.byId[action.programId],
            id: action.programId,
            isFetching: true
          }
        }
      };
    case 'GRAD_SCHOOLS_FETCH_PROGRAM_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.program.id]: {
            ...action.program,
            isFetching: false
          }
        }
      };
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
